import { Box, Fade, Grid, Grow, Typography } from "@mui/material";
import { ParentMeetingTopButtons } from "./ParentMeetingTopButtons";
import { MyColorButton } from "../../layoutPages/components/MyColorButton";
import MapIcon from '@mui/icons-material/Map';

export function PageParentContactUs() {
    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <ParentMeetingTopButtons />
            <Grid item xs={11} sm={10} sx={{ mt: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Typography variant="h5" sx={{ color: "#d485b4", fontSize: "2rem" }} >培僑小學</Typography>
            </Grid>
            <Grid item xs={11} sm={10}>
                <Box sx={{ borderRadius: "15px", backgroundColor: "white", width: "100%", p: 2 }}>
                    <Typography>
                        <b>地址 Primary mailing address:</b><br />
                        <a href="https://maps.app.goo.gl/B1GckuWtEVBf5Qp78" target="_blank" >12 Fu Yee Road, Siu Wan, Chai Wan, Hong Kong<br />
                            香港小西灣富怡道12號</a><br />
                        <hr />
                        <b>電話 Tel:</b> <a href="tel:28977866">28977866</a>  <br />
                        <b>傳真 Fax:</b> <a href="tel:28977883">28977883</a>  <br />
                        <b>本校電郵:</b> <a href="mailto:puikiu@pkps.edu.hk">puikiu@pkps.edu.hk</a> <br />
                        <hr />
                        <b>交通網絡:</b>本校鄰近小西灣及藍灣半島巴士總站，並設有47M<br />
                        62 專線小巴到達本校。(巴士路線: 8P、8X、82、82X、788、789、106、118、606等)
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={11} sm={10} sx={{ mt: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Typography variant="h5" sx={{ color: "orange", fontSize: "2rem" }}>聯會</Typography>
            </Grid>
            <Grid item xs={11} sm={10} sx={{ mb: 5 }}>
                <MyColorButton mainColor="orange" inverted={true} sx={{ fontSize: "1.5em", width: "100%", borderRadius: "10px", p: 2 }}
                    onClick={() => { window.open("https://www.pkppf.hk/p/42490") }}
                >
                    連結&nbsp;&nbsp;
                    <MapIcon />
                </MyColorButton>
            </Grid>
        </Grid>
    )
}